<section class="bg-color-0E0B33">
  <div class="white-screen" #whiteDrop>
    <!-- <div class="blur1" [ngClass]="{'stopSpin': showLogo}" *ngIf="startLogoSpin"></div>
    <div class="blur2" [ngClass]="{'stopSpin': showLogo}" *ngIf="startLogoSpin"></div>
    <div class="blur3" [ngClass]="{'stopSpin': showLogo}" *ngIf="startLogoSpin"></div>
    <div class="blur4" [ngClass]="{'stopSpin': showLogo}" *ngIf="startLogoSpin"></div>
    <div class="blur5" [ngClass]="{'stopSpin': showLogo}" *ngIf="startLogoSpin"></div> -->
    <div class="flex-row align-center content-center column-gap-10 logosection" *ngIf="startLogoSpin">
      <img class="logoSpin" [ngClass]="{'stopSpin': showLogo}" src="assets/logo/pickright-black-blue.png"
        alt="Pickright logo">
      <div class="logoName" *ngIf="showLogo" #logoName>
        <h2 class="tw-text-color-1 !tw-font-extrabold tw-tracking-wider">Pickright</h2>
        <!-- <img src="assets/logo/pickright.png" alt=""> -->
      </div>
    </div>
  </div>
  <div class="flex-row height-100-pr align-end pb-70 full" *ngIf="startLogoSpin && !showLogo">
    <div class="keen-slider height-6" style="z-index: 10;" #textSliderRef>
      <ng-container *ngFor="let item of runningText">
        <div class="flex-row column align-center keen-slider__slide text-center text-black fw-6 lh-24"
          [innerHTML]="item" [ngClass]="{'tw-invisible': !textSlider}"></div>
      </ng-container>
    </div>
  </div>
</section>